import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';

  path = pagination_params(params);

  params.CodigoEspecificacionTecnica &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEspecificacionTecnica=${encodeURIComponent(params.CodigoEspecificacionTecnica)}`);
  params.FechaDesde && (path = `${path !== '' ? `${path}&` : ''}FechaDesde=${params.FechaDesde}`);
  params.FechaHasta &&
    (path = `${path !== '' ? `${path}&` : ''}FechaHasta=${setHoursEndOfDate(params.FechaHasta)}`);
  params.Cliente && (path = `${path !== '' ? `${path}&` : ''}Cliente=${params.Cliente}`);
  if (params.CodigoUsuarioCreacion) {
    const codigos = Array.isArray(params.CodigoUsuarioCreacion)
      ? params.CodigoUsuarioCreacion
      : [params.CodigoUsuarioCreacion];
    codigos.forEach((codigo) => {
      path = `${path !== '' ? `${path}&` : ''}CodigoUsuario=${codigo}`;
    });
  }
  params.EstadoCotizacion &&
    params.EstadoCotizacion.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEstado=${params.EstadoCotizacion.Codigo}`);

  if (
    params.CodigosEstados &&
    Array.isArray(params.CodigosEstados) &&
    params.CodigosEstados.length > 0
  ) {
    path = `${path !== '' ? `${path}&` : ''}CodigosEstados=${params.CodigosEstados.join(',')}`;
  }

  params.FechaEstadoHasta &&
    (path = `${path !== '' ? `${path}&` : ''}FechaEstadoHasta=${params.FechaEstadoHasta}`);
  params.FechaEstadoDesde &&
    (path = `${path !== '' ? `${path}&` : ''}FechaEstadoDesde=${setHoursEndOfDate(params.FechaEstadoDesde)}`);
  params.Referencia && (path = `${path !== '' ? `${path}&` : ''}Referencia=${params.Referencia}`);
  params.AllCotizaciones &&
    (path = `${path !== '' ? `${path}&` : ''}AllCotizaciones=${params.AllCotizaciones}`);

  if (params.ElementoTipo && Array.isArray(params.ElementoTipo)) {
    const codigosElementoTipo = params.ElementoTipo.map((tipo) => tipo.Codigo);
    codigosElementoTipo.forEach((codigo) => {
      path = `${path !== '' ? `${path}&` : ''}CodigoElementoTipo=${encodeURIComponent(codigo)}`;
    });
  }
  params.CodigoEquivalente &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEquivalente=${params.CodigoEquivalente}`);
  params.CodigoAdicional &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoAdicional=${params.CodigoAdicional}`);
  params.DescripcionComercial &&
    (path = `${path !== '' ? `${path}&` : ''}DescripcionComercial=${encodeURIComponent(params.DescripcionComercial)}`);
  params.CodigoCotizacion &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoCotizacion=${encodeURIComponent(params.CodigoCotizacion)}`);
  params.CodigoUsabilidad &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoUsabilidad=${params.CodigoUsabilidad}`);
  params.Suaje &&
    (path = `${path !== '' ? `${path}&` : ''}Suaje=${encodeURIComponent(params.Suaje)}`);
  if (params.Procesos && Array.isArray(params.Procesos) && params.Procesos.length > 0) {
    const codigosProcesos = params.Procesos.map((p) => p.Codigo || p);
    const stringProcesos = codigosProcesos.join(',');
    path = `${path !== '' ? `${path}&` : ''}Procesos=${encodeURIComponent(stringProcesos)}`;
  }
  return path;
};

const setHoursEndOfDate = (fecha) => {
  if (fecha) {
    const fechaSeleccionada = new Date(fecha);
    fechaSeleccionada.setHours(23, 59, 59, 999);
    return fechaSeleccionada;
  }
  return fecha;
};
